import { render } from "./patient-signup.vue?vue&type=template&id=44ba847f&scoped=true"
import script from "./patient-signup.vue?vue&type=script&lang=js"
export * from "./patient-signup.vue?vue&type=script&lang=js"

import "./patient-signup.vue?vue&type=style&index=0&id=44ba847f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ba847f"]])

export default __exports__